import React, { createContext, useContext, useState, useEffect } from 'react';
import i18n from 'i18next';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // i18n의 현재 언어를 초기값으로 사용
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'ko');

  // i18n 언어 변경 이벤트 구독 (다른 컴포넌트에서 언어를 변경했을 때 동기화)
  useEffect(() => {
    const handleLanguageChange = (lng) => {
      setCurrentLanguage(lng);
    };

    i18n.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  // 언어 변경 함수
  const changeLanguage = (languageCode) => {
    localStorage.setItem('selectedLanguage', languageCode);
    i18n.changeLanguage(languageCode); // i18n 변경 -> languageChanged 이벤트 발생 -> setCurrentLanguage 호출
  };

  // 언어 정보
  const languages = [
    { code: 'ko', name: '한국어', flag: '🇰🇷' },
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'zh', name: '中文', flag: '🇨🇳' },
    { code: 'ja', name: '日本語', flag: '🇯🇵' }
  ];

  const getCurrentLanguageInfo = () => {
    return languages.find(lang => lang.code === currentLanguage) || languages[0];
  };

  const value = {
    currentLanguage,
    changeLanguage,
    languages,
    getCurrentLanguageInfo
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

